import { getFormById } from "@starter/Framework/Store/Starter/Components/Form/FormSelectors";
import { BaseFormHandlerParameter } from "@starter/Framework/Store/Starter/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface SetFormHandlerParameter extends BaseFormHandlerParameter {}

type HandlerType = Handler<SetFormHandlerParameter>;

export const DispatchSetForm: HandlerType = props => {
    const formExist = getFormById(props.getState(), props.parameter.formId);

    if (!formExist) {
        props.dispatch({
            type: "Starter/Components/Form/SetForm",
            parameter: props.parameter,
        });
    }
};

export const chain = [DispatchSetForm];

const setForm = createHandlerChainRunner(chain, "SetForm");

export default setForm;
